import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import camera from '../assets/images/svg/camera.svg';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';
import formatDate from '../helper/dateFormat';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const ProductShape = (props) => {

    const serverURL = getServerURL()
    const fileInputRef = useRef(null);

    const [modalShow, setModalShow] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [states, setStates] = useState({})
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([])
    const [deleteData, setDeleteData] = useState();
    const [loading, setLoading] = useState(true);
    const [subLoader, setSubLoader] = useState(false);
    const [mode, setMode] = useState();
    const [selectedImage, setSelectedImage] = useState();
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    useEffect(() => {
        getProductShape();
    }, [searchText, page]);

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    const getProductShape = (event) => {
        api.getWithToken(`${serverURL}product/shape/?page=${page}${searchText && `&_i=${searchText}`}`)
            .then(async (res) => {
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                setLoading(false)
                if (res?.data?.success === true) {
                    setData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "image") {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setSelectedImage(reader.result);
                };
                reader.readAsDataURL(file);
                setStates({
                    ...states,
                    [name]: file,
                });
            }
        } else
            setStates((prevValues) => ({
                ...prevValues,
                [name]: value.trimStart(),
            }));
    };

    const handleSubmit = (event) => {
        setSubLoader(true)
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity()) {
            setValidated(false);
            const type = Boolean(mode) ? "postWithToken" : "putWithToken";
            const formData = new FormData();
            formData.append("name", states?.name);
            formData.append("image", states?.image);
            if (states?.slug)
                formData.append("slug", states?.slug);

            api[type](`${serverURL}product/shape/`, formData)
                .then(async (res) => {
                    setModalShow(false)
                    setStates({})
                    form.reset();
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getProductShape();
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {

                    setSubLoader(false)
                    errorResponse(e);
                });
        } else {
            setValidated(true);
            setSubLoader(false)
            event.stopPropagation();
        }
    };

    const deleteProductShape = () => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}product/shape/${deleteData}`)
            .then(async (res) => {
                setDeleteModalShow(false)
                setSubLoader(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getProductShape()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
            })
            .catch((e) => {
                setSubLoader(false)
                errorResponse(e);
            });
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                                <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); setStates({}); setSelectedImage(""); setModalShow(true) }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Created At</th>
                                <th>Updated At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr key={index + "productShape"}>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <img className="rounded-circle" style={{ width: '100%', maxWidth: "40px", height: "40px" }} src={item?.image} alt="activity-user" />
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.name || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{formatDate(new Date(item?.created_at)) || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{formatDate(new Date(item?.updated_at)) || "-"}</h6>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); setSelectedImage(""); setModalShow(true) }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                <div className='cursor-pointer' onClick={() => { setDeleteData(item?.slug); setDeleteModalShow(true) }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={6} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}

            {/* add modal */}
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            {Boolean(subLoader) && <Loader loading={subLoader} />}
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter product shape name here" required value={states?.name || ""} name='name' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter product shape name.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className={`mb-3 ${!Boolean(mode) && "align-items-center"}`} as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        Image
                                    </Form.Label>
                                    <Col sm={9}>

                                        <div className="position-relative" id="profile_image">
                                            <div className="d-flex">
                                                <img
                                                    src={selectedImage || states?.image}
                                                    onClick={handleImageClick}
                                                    className={`cursor-pointer profile-image`}
                                                />
                                            </div>
                                            <input
                                                type="file"
                                                accept=".jpg, .jpeg, .png, webm, .webp"
                                                name="image"
                                                style={{ display: "none" }}
                                                ref={fileInputRef}
                                                onChange={handleChange}
                                            />

                                            <img
                                                src={camera}
                                                onClick={handleImageClick}
                                                className="cursor-pointer position-absolute top-50 start-20 translate-middle"
                                                alt=""
                                            />
                                        </div>

                                    </Col>
                                </Form.Group>

                                {/* <Form.Group className="mb-3" as={Row} controlId="formHorizontalImage">
                                    <Form.Label column sm={3}>
                                        Image
                                    </Form.Label>
                                    <Col sm={9}>
                                        <InputGroup className="mb-3">
                                            <Form.Control aria-describedby="custom-addons6" type="file" className="custom-file-input" id="validatedCustomFile2" required name='image' onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">Please select image.</Form.Control.Feedback>
                                        </InputGroup>
                                    </Col>
                                </Form.Group> */}

                                <div className='d-flex justify-content-end'>
                                    <Button type='submit' className='m-0'>{Boolean(mode) ? "Save" : "Update"}</Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

            {/* Delete */}
            <Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deleteProductShape()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ProductShape